import Masonry from 'masonry-layout';
import './blocks-fondi.scss';
/**
 * version    1.0
 * class      BlocksFondi
 * classdesc  Gestisce il layout a griglia Masonry
 */
export class BlocksFondi {
  constructor() {
    this.container = document.querySelector('.blocks-fondi__container');
    if (!this.container) return;

    this.initMasonry();

    setTimeout(() => {
      this.layout();
    }, 2000);

    setTimeout(() => {
      this.layout();
    }, 5000);
  }

  initMasonry() {
    this.msnry = new Masonry(this.container, {
      itemSelector: '.blocks-fondi__card',
      columnWidth: '.blocks-fondi__card', // calcola in base al primo elemento
      gutter: 32,
      percentPosition: true,
      horizontalOrder: true, // riempie da sinistra a destra
    });
  }

  reloadItems() {
    if (this.msnry) {
      this.msnry.reloadItems();
    }
  }

  // Ricalcola la griglia dopo modifiche
  layout() {
    if (this.msnry) {
      this.msnry.layout();
    }
  }
}
